export default {"src":"/_next/static/media/assistant-soldier.8766bdf3.svg","height":273,"width":288};